import Kebab from './Kebab';

export default Kebab;
